import { UploadCareImageProps, getUploadCareUrl } from '@dentalux/ui-library-core/utils/image'

export const getImageUrl = ({ quality = 'smart', ...restProps }: UploadCareImageProps) => {
  return getUploadCareUrl({ quality, ...restProps })
}

export const getImageUrlWithTransformations = ({
  src,
  format = 'webp',
  filter,
  invert,
  quality,
  transformations = [],
}: UploadCareImageProps) => {
  const params = [
    `-/format/${format}/`,
    filter && `-/filter/${filter}/`,
    invert && '-/invert/',
    quality && `-/quality/${quality}/`,
    ...transformations.map((transformation) => transformation.toValue()),
  ].filter(Boolean)

  const divider = src.endsWith('/') ? '' : '/'

  return `${src}${divider}${params.join('')}`
}
